// Authorize
import AuthorizeRequest from './authorize/Request.json';
// Camera
import CameraChangeLens from './camera/ChangeLens.json';
import CameraGimbal from './camera/Gimbal.json';
import CameraStreamingStart from './camera/StreamingStart.json';
import CameraStreamingStop from './camera/StreamingStop.json';
// Flight Control
import FlightControlBrake from './flight-control/Brake.json';
import FlightControlDrcModeEnter from './flight-control/DrcModeEnter.json';
import FlightControlDrcModeExit from './flight-control/DrcModeExit.json';
import FlightControlGoto from './flight-control/Goto.json';
import FlightControlGotoUpdate from './flight-control/GotoUpdate.json';
import FlightControlHeartbeat from './flight-control/Heartbeat.json';
import FlightControlReturnHome from './flight-control/ReturnHome.json';
import FlightControlStickControl from './flight-control/StickControl.json';
import FlightControlTakeoff from './flight-control/Takeoff.json';
import FlightControlTakeoffSimulation from './flight-control/TakeoffSimulation.json';
// Mission
import MissionClear from './mission/Clear.json';
import MissionPause from './mission/Pause.json';
import MissionRequestsReply from './mission/RequestsReply.json';
import MissionResume from './mission/Resume.json';
import MissionStart from './mission/Start.json';
import MissionUpload from './mission/Upload.json';
import MissionUploadSimulation from './mission/UploadSimulation.json';
// Remote Debug
import RemoteDebugAircraftCharge from './remote-debug/AircraftCharge.json';
import RemoteDebugAircraftPower from './remote-debug/AircraftPower.json';
import RemoteDebugDebugMode from './remote-debug/DebugMode.json';
import RemoteDebugDockCanopy from './remote-debug/DockCanopy.json';
import RemoteDebugDockRestart from './remote-debug/DockRestart.json';
import RemoteDebugEventsReply from './remote-debug/EventsReply.json';

const messages = [
  // Authorize
  AuthorizeRequest,
  // Camera
  CameraChangeLens,
  CameraGimbal,
  CameraStreamingStart,
  CameraStreamingStop,
  // Flight Control
  FlightControlBrake,
  FlightControlDrcModeEnter,
  FlightControlDrcModeExit,
  FlightControlGoto,
  FlightControlGotoUpdate,
  FlightControlHeartbeat,
  FlightControlReturnHome,
  FlightControlStickControl,
  FlightControlTakeoff,
  FlightControlTakeoffSimulation,
  // Mission
  MissionClear,
  MissionPause,
  MissionRequestsReply,
  MissionResume,
  MissionStart,
  MissionUpload,
  MissionUploadSimulation,
  // Remote Debug
  RemoteDebugAircraftCharge,
  RemoteDebugAircraftPower,
  RemoteDebugDebugMode,
  RemoteDebugDockCanopy,
  RemoteDebugDockRestart,
  RemoteDebugEventsReply,
];

const messageSet = {};
messages.forEach((message) => {
  messageSet[message.name] = {
    topic: message.topic,
    fields: message.fields,
  };
});

export default messageSet;
